export const LOGO_ALT = 'iQx';
